import React from "react";
import { cn } from "../../u1/cn";

/* Static explainer beside the claim intake — what the owner can do with the
   profile they now hold. ICC-01 removed the review queue, so none of these
   steps is something the user waits on. */
export const CLAIM_NEXT_STEPS = [
  {
    title: "The profile is yours",
    body: "Ownership transfers the moment you finish — there is no approval step.",
  },
  {
    title: "Complete the details",
    body: "Edit the profile, add your industries, and upload supporting documents.",
  },
  {
    title: "Start receiving enquiries",
    body: "Buyers, banks, and insurers can reach you through the profile straight away.",
  },
  {
    title: "Apply for Verified",
    body: "Optional — add your trade licence to request TREVEX-verified status.",
  },
];

export const WhatHappensNext = ({
  title = "What happens next",
  steps = CLAIM_NEXT_STEPS,
  className = "",
}) => (
  <section
    aria-labelledby="what-happens-next"
    className={cn("rounded-xl border border-[var(--line)] bg-white p-5", className)}
  >
    <h2
      id="what-happens-next"
      className="text-[11px] font-semibold uppercase tracking-[0.06em] text-[var(--muted)] font-sans"
    >
      {title}
    </h2>

    <ol className="mt-3.5 grid gap-3.5">
      {steps.map((step, i) => (
        <li key={step.title} className="flex gap-3">
          {/* The marker repeats the list position, so it is decorative — an
              ordered list already conveys the order. */}
          <span
            aria-hidden="true"
            className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[var(--field-inset)] text-[11px] font-bold text-[var(--ink)] font-sans"
          >
            {i + 1}
          </span>
          <div>
            <div className="text-[13px] font-semibold text-[var(--ink)] font-sans">
              {step.title}
            </div>
            <p className="mt-0.5 text-[12.5px] leading-[1.5] text-[var(--muted)] font-sans">
              {step.body}
            </p>
          </div>
        </li>
      ))}
    </ol>
  </section>
);

export default WhatHappensNext;
